module.exports = __webpack_public_path__ + "162e2a6dee806dcf95820f5a2e0aa4d1.png";


//////////////////
// WEBPACK FOOTER
// ./images/icon-menu.png
// module id = ./images/icon-menu.png
// module chunks = 5